import { gql } from '@apollo/client';

export const FETCH_ELIGIBLE_BY_SEQUENCE_GROUP = gql`
	query eligibleCrewMembersBySequenceGroup(
		$workAssignmentSequenceGroupId: ID
		$fromStationId: ID!
		$toStationId: ID!
		$activityType: ActivityType!
	) {
		eligibleCrewMembersV2(
			workAssignmentSequenceGroupId: $workAssignmentSequenceGroupId
			fromStationId: $fromStationId
			toStationId: $toStationId
			activityType: $activityType
		) {
			crewMember {
				id
				fullName
				driverCard
				role
				isActive
				phone
				currentEmploymentType {
					employmentType
				}
				lastWorkAssignment {
					activity {
						title
						rideId
					}
				}
				groups {
					name
				}
				currentRun {
					name
				}
				currentJobs {
					code
				}
				currentHomeBase {
					city {
						name
						id
					}
				}
				holdDowns {
					id
					crewMember {
						id
						fullName
					}
					originalCrewMember {
						id
						fullName
						email
					}
					effectiveTimestamp
					expireTimestamp
					note
					createdAt
					updatedBy
				}
			}
			availabilityInfo {
				remainingCapacityMinutes
				nextAvailability
				idleTimeMinutes
				timeToFreshMinutes
				maxCapacityMinutes
				maxWorkingCapacityMinutes
				remainingWorkingCapacityMinutes
				isDestinationHomeBase
				isProtectionInDepartureLocation
			}
		}
	}
`;
